// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* IntentIndex.module.css */

.IntentIndex_manageButton__-IGLD {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #10b981;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 15px;
}

.IntentIndex_manageButton__-IGLD:hover {
  background: #059669;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

/* Create Intent Button */
.IntentIndex_createIntentButton__cKwLI {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #4f46e5;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 12px;
}

.IntentIndex_createIntentButton__cKwLI:hover {
  background: #4338ca;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
}

.IntentIndex_createIntentButton__cKwLI svg {
  font-size: 16px;
}

/* App Level Badge */
.IntentIndex_appLevelBadge__4cB5A {
  display: inline-block;
  background: #f59e0b;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 12px;
  margin-left: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Modal Overlay */
.IntentIndex_modalOverlay__0M55x {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.IntentIndex_modalContent__ZUqfy {
  background: white;
  border-radius: 16px;
  padding: 32px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.IntentIndex_modalContent__ZUqfy h3 {
  margin-top: 0;
  margin-bottom: 8px;
  color: #1a1a2e;
  font-size: 22px;
}

.IntentIndex_modalContent__ZUqfy p {
  color: #666;
  margin-bottom: 24px;
  font-size: 14px;
}

.IntentIndex_modalInput__iy28B,
.IntentIndex_modalTextarea__3jzSr {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
  background: #f9fafb;
}

.IntentIndex_modalInput__iy28B:focus,
.IntentIndex_modalTextarea__3jzSr:focus {
  outline: none;
  border-color: #4f46e5;
  background: white;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.IntentIndex_modalTextarea__3jzSr {
  resize: vertical;
  font-family: inherit;
}

.IntentIndex_modalActions__nwGbx {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.IntentIndex_modalCancelBtn__TSoPx {
  padding: 10px 20px;
  background: #f3f4f6;
  color: #374151;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.IntentIndex_modalCancelBtn__TSoPx:hover:not(:disabled) {
  background: #e5e7eb;
}

.IntentIndex_modalCreateBtn__52sBJ {
  padding: 10px 24px;
  background: #4f46e5;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.IntentIndex_modalCreateBtn__52sBJ:hover:not(:disabled) {
  background: #4338ca;
  transform: translateY(-1px);
}

.IntentIndex_modalCreateBtn__52sBJ:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.IntentIndex_modalContent__ZUqfy small {
  display: block;
  margin-top: 4px;
}

.IntentIndex_modeBadge__DDvWR {
  background-color: #6c757d;
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  margin-left: 4px;
}

.IntentIndex_modeBadge__DDvWR.IntentIndex_chain__C6x6e {
  background-color: #6f42c1;
}

.IntentIndex_modeBadge__DDvWR.IntentIndex_api__nxNT6 {
  background-color: #0d6efd;
}

.IntentIndex_deleteButton__LcvC5 {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-left: 8px;
}

.IntentIndex_deleteButton__LcvC5:hover {
  background-color: #c82333;
}

.IntentIndex_deleteButton__LcvC5:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.IntentIndex_actionButtons__1Q5Zc {
  display: flex;
  gap: 8px;
  align-items: center;
}
/* Add these styles for the toggle functionality */

.IntentIndex_badgeDisabled__HxJDD {
  background-color: #ff9800;
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.IntentIndex_badgeContainer__4v5Fm {
  display: flex;
  align-items: center;
  gap: 8px;
}

.IntentIndex_toggleActiveBtn__yVJil {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.IntentIndex_toggleActiveBtn__yVJil:hover {
  background-color: #c82333;
  transform: scale(1.05);
}

.IntentIndex_toggleActiveBtn__yVJil:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.IntentIndex_toggleDisabledBtn__dhA7I {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.IntentIndex_toggleDisabledBtn__dhA7I:hover {
  background-color: #218838;
  transform: scale(1.05);
}

.IntentIndex_toggleDisabledBtn__dhA7I:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.IntentIndex_cardSaved__FHj2R {
  border-left: 4px solid #28a745;
}

.IntentIndex_cardUnsaved__OjZBu {
  border-left: 4px solid #ffc107;
}

.IntentIndex_activeConfigInfo__Axuza {
  margin-top: 12px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  font-size: 13px;
  border-left: 3px solid #28a745;
}

/* Update existing styles */
.IntentIndex_badgeConfigured__LMvIj {
  background-color: #28a745;
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.IntentIndex_aiAgentWrapper__CQNb7 {
  margin: 0 auto;
  width: 100%;
}

.IntentIndex_headerSection__c\\+V2b {
  text-align: center;
  /* margin-bottom: 32px; */
  padding-bottom: 24px;
  border-bottom: 2px solid #e9ecef;
}

.IntentIndex_title__GbgFO {
  font-size: 2rem;
  font-weight: 700;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; */
  /* background-clip: text; */
  margin-bottom: 12px;
  letter-spacing: -0.5px;
  color: var(--dark-color);
}

.IntentIndex_subtitle__9TWEj {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.5;
  margin-top: 8px;
}

.IntentIndex_cardWrap__eSmM0 {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  margin-bottom: 32px;
}

.IntentIndex_cards__8YOfV {
  /* background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%); */
  border-radius: 12px;
  padding: 24px;
  transition: all 0.3s ease;
  width: 100%;
  border: 1px solid #e9ecef;
  box-shadow: var(--shadow-md);
}

.IntentIndex_cards__8YOfV:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  box-shadow: var(--cardBox-shadow-hover);
}
.IntentIndex_cardSaved__FHj2R {
  border-left: 4px solid #28a745;
  background: linear-gradient(135deg, #ffffff 0%, #f0f9f0 100%);
}

.IntentIndex_cardUnsaved__OjZBu {
  border-left: 4px solid #ff9800;
  background: var(--white-color);
}

.IntentIndex_cardHeader__IeGM\\+ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e9ecef;
}

.IntentIndex_cardTitleSection__ZTSdq {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.IntentIndex_savedTitle__tQ\\+po {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #28a745;
}

.IntentIndex_unsavedTitle__szXhM {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #495057;
}

.IntentIndex_badgeContainer__4v5Fm {
  display: inline-flex;
}

.IntentIndex_badgeConfigured__LMvIj {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.IntentIndex_badgeNotConfigured__yy--W {
  background: linear-gradient(135deg, #ff9800 0%, #ffc107 100%);
  color: var(--white-color);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.IntentIndex_actionButtons__1Q5Zc {
  display: flex;
  gap: 8px;
}

.IntentIndex_editButton__\\+GmXX {
  padding: 6px 16px;
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  color: var(--white-color);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.IntentIndex_editButton__\\+GmXX:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
}

.IntentIndex_cancelButton__rZ9ro {
  padding: 6px 16px;
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
  color: var(--white-color);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.IntentIndex_cancelButton__rZ9ro:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.3);
}

.IntentIndex_formGroup__XBc1B {
  margin-bottom: 20px;
}

.IntentIndex_formLabel__auU0O strong {
  font-weight: 600;
  color: #495057;
  font-size: 0.875rem;
  background-color: transparent;
  padding: 0;
  border-radius: 0;
}

.IntentIndex_selectInput__kOBKn {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  margin-top: 15px;
  background-color: var(--white-color);
}

.IntentIndex_selectInput__kOBKn:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.IntentIndex_selectInput__kOBKn:disabled {
  background-color: #f8f9fa;
  cursor: not-allowed;
  opacity: 0.7;
}

.IntentIndex_selectedConfigInfo__aTcat {
  margin-top: 12px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdef5 100%);
  padding: 12px;
  border-radius: 8px;
  font-size: 0.813rem;
  color: #1976d2;
  border-left: 3px solid #2196f3;
}

.IntentIndex_formFieldsSection__6HhHW {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e9ecef;
}

.IntentIndex_sectionTitle__zBaxI {
  font-weight: 600;
  margin-bottom: 12px;
  color: #6c757d;
  font-size: 0.875rem;
}

.IntentIndex_saveButtonContainer__x\\+RBD {
  margin-top: 20px;
}

.IntentIndex_saveButton__yYXa9 {
  width: 100%;
  padding: 12px 24px;
  background: var(--saveBtn);
  color: var(--white-color);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.IntentIndex_saveButton__yYXa9:hover {
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  background-color: var(--saveHover);
}

.IntentIndex_activeConfigInfo__Axuza {
  margin-top: 16px;
  padding: 12px;
  background: #1b8f36;
  border-radius: 8px;
  font-size: 0.813rem;
  color: var(--white-color);
  border-left: 3px solid #28a745;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.IntentIndex_activeConfigInfo__Axuza strong {
  background: #46c764;
}
.IntentIndex_summarySection__WHhyD {
  margin-top: 32px;
  padding: 24px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  border: 1px solid #e9ecef;
  box-shadow: var(--shadow-md);
}

.IntentIndex_summaryTitle__vKRtZ {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 20px;
  color: #495057;
  padding-bottom: 12px;
  border-bottom: 2px solid #e9ecef;
}

.IntentIndex_summaryGrid__rykHN {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.IntentIndex_summaryItem__jlcmc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.IntentIndex_summaryItem__jlcmc:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.IntentIndex_summaryLabel__UVvmL {
  font-weight: 600;
  color: #6c757d;
  font-size: 0.875rem;
}

.IntentIndex_summaryValue__9lgzF {
  color: #495057;
  font-weight: 500;
  font-size: 0.875rem;
  font-family: "Courier New", monospace;
}

/* Responsive Design */
@media (max-width: 768px) {
  .IntentIndex_aiAgentWrapper__CQNb7 {
    padding: 16px;
  }

  .IntentIndex_title__GbgFO {
    font-size: 1.5rem;
  }

  .IntentIndex_cards__8YOfV {
    padding: 16px;
  }

  .IntentIndex_cardHeader__IeGM\\+ {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .IntentIndex_actionButtons__1Q5Zc {
    width: 100%;
  }

  .IntentIndex_editButton__\\+GmXX,
  .IntentIndex_cancelButton__rZ9ro {
    flex: 1 1;
    text-align: center;
  }

  .IntentIndex_summaryGrid__rykHN {
    grid-template-columns: 1fr;
  }
}

/* Animation for card entrance */
@keyframes IntentIndex_slideIn__d9N9Z {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.IntentIndex_cards__8YOfV {
  animation: IntentIndex_slideIn__d9N9Z 0.3s ease-out;
}
.IntentIndex_customSelect__8\\+qHE {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 30px; /* Make space for custom icon */
  cursor: pointer;
}

.IntentIndex_customSelect__8\\+qHE::-ms-expand {
  display: none; /* Hide arrow in IE/Edge */
}

.IntentIndex_customSelect__8\\+qHE::-ms-expand {
  display: none; /* Hide arrow in IE/Edge */
}

.IntentIndex_selectWrapper__0R83K {
  position: relative;
  display: inline-block;
  width: 100%;
}

.IntentIndex_selectIcon__FNPxK {
  position: absolute;
  right: 10px;
  top: 60%;
  transform: translateY(-50%);
  pointer-events: none; /* Allow clicks to pass through to select */
  color: #666;
}

@media (max-width: 480px) {
  .IntentIndex_aiAgentWrapper__CQNb7 {
    padding: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/IntentIndex.module.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA,kDAAkD;;AAElD;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB;;yCAEuC;EACvC,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mEAAmE;EACnE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;AACzC;AACA;EACE,8BAA8B;EAC9B,6DAA6D;AAC/D;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6DAA6D;EAC7D,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mDAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB,EAAE,+BAA+B;EACpD,eAAe;AACjB;;AAEA;EACE,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB,EAAE,2CAA2C;EACjE,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["/* IntentIndex.module.css */\n\n.manageButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #10b981;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 15px;\n}\n\n.manageButton:hover {\n  background: #059669;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n/* Create Intent Button */\n.createIntentButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #4f46e5;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 12px;\n}\n\n.createIntentButton:hover {\n  background: #4338ca;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n}\n\n.createIntentButton svg {\n  font-size: 16px;\n}\n\n/* App Level Badge */\n.appLevelBadge {\n  display: inline-block;\n  background: #f59e0b;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 12px;\n  margin-left: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Modal Overlay */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.modalContent {\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modalContent h3 {\n  margin-top: 0;\n  margin-bottom: 8px;\n  color: #1a1a2e;\n  font-size: 22px;\n}\n\n.modalContent p {\n  color: #666;\n  margin-bottom: 24px;\n  font-size: 14px;\n}\n\n.modalInput,\n.modalTextarea {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n  background: #f9fafb;\n}\n\n.modalInput:focus,\n.modalTextarea:focus {\n  outline: none;\n  border-color: #4f46e5;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.modalTextarea {\n  resize: vertical;\n  font-family: inherit;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.modalCancelBtn {\n  padding: 10px 20px;\n  background: #f3f4f6;\n  color: #374151;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.modalCancelBtn:hover:not(:disabled) {\n  background: #e5e7eb;\n}\n\n.modalCreateBtn {\n  padding: 10px 24px;\n  background: #4f46e5;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.modalCreateBtn:hover:not(:disabled) {\n  background: #4338ca;\n  transform: translateY(-1px);\n}\n\n.modalCreateBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.modalContent small {\n  display: block;\n  margin-top: 4px;\n}\n\n.modeBadge {\n  background-color: #6c757d;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  margin-left: 4px;\n}\n\n.modeBadge.chain {\n  background-color: #6f42c1;\n}\n\n.modeBadge.api {\n  background-color: #0d6efd;\n}\n\n.deleteButton {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 6px 16px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  margin-left: 8px;\n}\n\n.deleteButton:hover {\n  background-color: #c82333;\n}\n\n.deleteButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.actionButtons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n/* Add these styles for the toggle functionality */\n\n.badgeDisabled {\n  background-color: #ff9800;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.badgeContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.toggleActiveBtn {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.toggleActiveBtn:hover {\n  background-color: #c82333;\n  transform: scale(1.05);\n}\n\n.toggleActiveBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.toggleDisabledBtn {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.toggleDisabledBtn:hover {\n  background-color: #218838;\n  transform: scale(1.05);\n}\n\n.toggleDisabledBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.cardSaved {\n  border-left: 4px solid #28a745;\n}\n\n.cardUnsaved {\n  border-left: 4px solid #ffc107;\n}\n\n.activeConfigInfo {\n  margin-top: 12px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  font-size: 13px;\n  border-left: 3px solid #28a745;\n}\n\n/* Update existing styles */\n.badgeConfigured {\n  background-color: #28a745;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.aiAgentWrapper {\n  margin: 0 auto;\n  width: 100%;\n}\n\n.headerSection {\n  text-align: center;\n  /* margin-bottom: 32px; */\n  padding-bottom: 24px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: 700;\n  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent; */\n  /* background-clip: text; */\n  margin-bottom: 12px;\n  letter-spacing: -0.5px;\n  color: var(--dark-color);\n}\n\n.subtitle {\n  color: #6c757d;\n  font-size: 1rem;\n  line-height: 1.5;\n  margin-top: 8px;\n}\n\n.cardWrap {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  margin-bottom: 32px;\n}\n\n.cards {\n  /* background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%); */\n  border-radius: 12px;\n  padding: 24px;\n  transition: all 0.3s ease;\n  width: 100%;\n  border: 1px solid #e9ecef;\n  box-shadow: var(--shadow-md);\n}\n\n.cards:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  box-shadow: var(--cardBox-shadow-hover);\n}\n.cardSaved {\n  border-left: 4px solid #28a745;\n  background: linear-gradient(135deg, #ffffff 0%, #f0f9f0 100%);\n}\n\n.cardUnsaved {\n  border-left: 4px solid #ff9800;\n  background: var(--white-color);\n}\n\n.cardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.cardTitleSection {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.savedTitle {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #28a745;\n}\n\n.unsavedTitle {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #495057;\n}\n\n.badgeContainer {\n  display: inline-flex;\n}\n\n.badgeConfigured {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.badgeNotConfigured {\n  background: linear-gradient(135deg, #ff9800 0%, #ffc107 100%);\n  color: var(--white-color);\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.actionButtons {\n  display: flex;\n  gap: 8px;\n}\n\n.editButton {\n  padding: 6px 16px;\n  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);\n  color: var(--white-color);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.editButton:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);\n}\n\n.cancelButton {\n  padding: 6px 16px;\n  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);\n  color: var(--white-color);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.cancelButton:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.3);\n}\n\n.formGroup {\n  margin-bottom: 20px;\n}\n\n.formLabel strong {\n  font-weight: 600;\n  color: #495057;\n  font-size: 0.875rem;\n  background-color: transparent;\n  padding: 0;\n  border-radius: 0;\n}\n\n.selectInput {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  transition: all 0.3s ease;\n  margin-top: 15px;\n  background-color: var(--white-color);\n}\n\n.selectInput:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.selectInput:disabled {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.selectedConfigInfo {\n  margin-top: 12px;\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdef5 100%);\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 0.813rem;\n  color: #1976d2;\n  border-left: 3px solid #2196f3;\n}\n\n.formFieldsSection {\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #e9ecef;\n}\n\n.sectionTitle {\n  font-weight: 600;\n  margin-bottom: 12px;\n  color: #6c757d;\n  font-size: 0.875rem;\n}\n\n.saveButtonContainer {\n  margin-top: 20px;\n}\n\n.saveButton {\n  width: 100%;\n  padding: 12px 24px;\n  background: var(--saveBtn);\n  color: var(--white-color);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.saveButton:hover {\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n  background-color: var(--saveHover);\n}\n\n.activeConfigInfo {\n  margin-top: 16px;\n  padding: 12px;\n  background: #1b8f36;\n  border-radius: 8px;\n  font-size: 0.813rem;\n  color: var(--white-color);\n  border-left: 3px solid #28a745;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.activeConfigInfo strong {\n  background: #46c764;\n}\n.summarySection {\n  margin-top: 32px;\n  padding: 24px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n  box-shadow: var(--shadow-md);\n}\n\n.summaryTitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n  color: #495057;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.summaryGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.summaryItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n  transition: all 0.3s ease;\n}\n\n.summaryItem:hover {\n  transform: translateX(4px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.summaryLabel {\n  font-weight: 600;\n  color: #6c757d;\n  font-size: 0.875rem;\n}\n\n.summaryValue {\n  color: #495057;\n  font-weight: 500;\n  font-size: 0.875rem;\n  font-family: \"Courier New\", monospace;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .aiAgentWrapper {\n    padding: 16px;\n  }\n\n  .title {\n    font-size: 1.5rem;\n  }\n\n  .cards {\n    padding: 16px;\n  }\n\n  .cardHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .actionButtons {\n    width: 100%;\n  }\n\n  .editButton,\n  .cancelButton {\n    flex: 1;\n    text-align: center;\n  }\n\n  .summaryGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Animation for card entrance */\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.cards {\n  animation: slideIn 0.3s ease-out;\n}\n.customSelect {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 30px; /* Make space for custom icon */\n  cursor: pointer;\n}\n\n.customSelect::-ms-expand {\n  display: none; /* Hide arrow in IE/Edge */\n}\n\n.customSelect::-ms-expand {\n  display: none; /* Hide arrow in IE/Edge */\n}\n\n.selectWrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.selectIcon {\n  position: absolute;\n  right: 10px;\n  top: 60%;\n  transform: translateY(-50%);\n  pointer-events: none; /* Allow clicks to pass through to select */\n  color: #666;\n}\n\n@media (max-width: 480px) {\n  .aiAgentWrapper {\n    padding: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manageButton": `IntentIndex_manageButton__-IGLD`,
	"createIntentButton": `IntentIndex_createIntentButton__cKwLI`,
	"appLevelBadge": `IntentIndex_appLevelBadge__4cB5A`,
	"modalOverlay": `IntentIndex_modalOverlay__0M55x`,
	"modalContent": `IntentIndex_modalContent__ZUqfy`,
	"modalInput": `IntentIndex_modalInput__iy28B`,
	"modalTextarea": `IntentIndex_modalTextarea__3jzSr`,
	"modalActions": `IntentIndex_modalActions__nwGbx`,
	"modalCancelBtn": `IntentIndex_modalCancelBtn__TSoPx`,
	"modalCreateBtn": `IntentIndex_modalCreateBtn__52sBJ`,
	"modeBadge": `IntentIndex_modeBadge__DDvWR`,
	"chain": `IntentIndex_chain__C6x6e`,
	"api": `IntentIndex_api__nxNT6`,
	"deleteButton": `IntentIndex_deleteButton__LcvC5`,
	"actionButtons": `IntentIndex_actionButtons__1Q5Zc`,
	"badgeDisabled": `IntentIndex_badgeDisabled__HxJDD`,
	"badgeContainer": `IntentIndex_badgeContainer__4v5Fm`,
	"toggleActiveBtn": `IntentIndex_toggleActiveBtn__yVJil`,
	"toggleDisabledBtn": `IntentIndex_toggleDisabledBtn__dhA7I`,
	"cardSaved": `IntentIndex_cardSaved__FHj2R`,
	"cardUnsaved": `IntentIndex_cardUnsaved__OjZBu`,
	"activeConfigInfo": `IntentIndex_activeConfigInfo__Axuza`,
	"badgeConfigured": `IntentIndex_badgeConfigured__LMvIj`,
	"aiAgentWrapper": `IntentIndex_aiAgentWrapper__CQNb7`,
	"headerSection": `IntentIndex_headerSection__c+V2b`,
	"title": `IntentIndex_title__GbgFO`,
	"subtitle": `IntentIndex_subtitle__9TWEj`,
	"cardWrap": `IntentIndex_cardWrap__eSmM0`,
	"cards": `IntentIndex_cards__8YOfV`,
	"cardHeader": `IntentIndex_cardHeader__IeGM+`,
	"cardTitleSection": `IntentIndex_cardTitleSection__ZTSdq`,
	"savedTitle": `IntentIndex_savedTitle__tQ+po`,
	"unsavedTitle": `IntentIndex_unsavedTitle__szXhM`,
	"badgeNotConfigured": `IntentIndex_badgeNotConfigured__yy--W`,
	"editButton": `IntentIndex_editButton__+GmXX`,
	"cancelButton": `IntentIndex_cancelButton__rZ9ro`,
	"formGroup": `IntentIndex_formGroup__XBc1B`,
	"formLabel": `IntentIndex_formLabel__auU0O`,
	"selectInput": `IntentIndex_selectInput__kOBKn`,
	"selectedConfigInfo": `IntentIndex_selectedConfigInfo__aTcat`,
	"formFieldsSection": `IntentIndex_formFieldsSection__6HhHW`,
	"sectionTitle": `IntentIndex_sectionTitle__zBaxI`,
	"saveButtonContainer": `IntentIndex_saveButtonContainer__x+RBD`,
	"saveButton": `IntentIndex_saveButton__yYXa9`,
	"summarySection": `IntentIndex_summarySection__WHhyD`,
	"summaryTitle": `IntentIndex_summaryTitle__vKRtZ`,
	"summaryGrid": `IntentIndex_summaryGrid__rykHN`,
	"summaryItem": `IntentIndex_summaryItem__jlcmc`,
	"summaryLabel": `IntentIndex_summaryLabel__UVvmL`,
	"summaryValue": `IntentIndex_summaryValue__9lgzF`,
	"slideIn": `IntentIndex_slideIn__d9N9Z`,
	"customSelect": `IntentIndex_customSelect__8+qHE`,
	"selectWrapper": `IntentIndex_selectWrapper__0R83K`,
	"selectIcon": `IntentIndex_selectIcon__FNPxK`
};
export default ___CSS_LOADER_EXPORT___;
